import type { AgentInstallCommand } from './types.js';
import { runNpmGlobalInstall } from './run-npm-global-install.js';

export const claudeCodeInstallCommand: AgentInstallCommand = {
  agentType: 'claude-code',
  detectCommand: 'claude',
  async install(ctx) {
    const logOutput = await runNpmGlobalInstall('@anthropic-ai/claude-code', {
      ...ctx.env,
      ANTHROPIC_API_KEY: ctx.authToken,
    });
    ctx.onProgress?.('Installing Anthropic Claude Code', logOutput || undefined);
  },
};
